import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createGameTypeService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.gameType, payload)).data;
};

export const getGameTypeService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.gameType}`, signal)).data; 
}

export const getActiveGameTypeService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.gameType}/active`, signal)).data; 
}

export const updateGameTypeService = async (payload) => {
  let filteredPayload = {
    "gameTypeId" : payload.gameTypeId,
    "gameType": payload.gameType,
    "status": payload.status,
  }
  return (await axiosInstance.put(`${APIROUTE.gameType}/${payload.gameTypeId}`, filteredPayload)).data;
};